import { secured } from '../plugins/axios';

const resource = '/businesses/admin/businesses';
const photosResource = '/businesses/admin/business-photos';

export default {
    all: filters => secured.get(`${resource}/`, { params: filters }),
    get: id => secured.get(`${resource}/${id}/`),
    updateImage: (id, payload, headers) => secured.patch(`${resource}/${id}/`, payload, headers),
    update: payload => secured.patch(`${resource}/${payload.id}/`, payload),
    create: payload => secured.post(`${resource}/`, payload),
    duplicate: id => secured.post(`${resource}/${id}/duplicate/`),
    delete: id => secured.delete(`${resource}/${id}/`),

    addImageUrl: (formData, headers) => secured.post(`${photosResource}/`, formData, headers),
    deleteImageUrl: photoId => secured.delete(`${photosResource}/${photoId}/`),
};
